import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Gate a page by role. If the user's role isn't in `roles`, redirect to /dashboard.
 * If status is anonymous, AppShell already kicks out to /login, so we just guard role here.
 */
export function RoleGate({ roles, children }) {
  const { user, status } = useAuth();
  const location = useLocation();

  if (status === "loading") return null;
  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!roles.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
